import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b376b76"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "checked", "disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox" }, null, -1))
const _hoisted_3 = ["innerHTML"]

import { withDefaults } from 'vue'

interface Props {
  name: string
  displayName: string
  checked: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCheckbox',
  props: {
    name: null,
    displayName: null,
    checked: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as { name: string, displayName: string, checked: boolean, disabled: boolean }

/**
 * AppCheckbox.
 *
 * チェックボックス
 */





const onChange = (event: Event) => {
  if (props.disabled) return

  const target = event.currentTarget

  if (!(target instanceof HTMLInputElement)) return

  const params = {
    name: props.name,
    checked: !props.checked,
  }
  emit('change', params, event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    tabIndex: 0,
    class: _normalizeClass(["appCheckbox", { disabled: __props.disabled }])
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      name: __props.name,
      checked: __props.checked,
      disabled: __props.disabled,
      class: "input",
      onChange: onChange
    }, null, 40, _hoisted_1),
    _hoisted_2,
    _createElementVNode("span", {
      class: "text",
      innerHTML: __props.displayName
    }, null, 8, _hoisted_3)
  ], 2))
}
}

})